(function () {
  function initHeroSliders() {
    document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
      var slides = root.querySelectorAll('.hero-slide');
      var dots = root.querySelectorAll('.hero-slider__dot');
      if (!slides.length) return;

      var index = 0;
      var interval = parseInt(root.getAttribute('data-interval') || '6000', 10);

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) {
          s.classList.toggle('is-active', j === index);
        });
        dots.forEach(function (d, j) {
          d.classList.toggle('is-active', j === index);
        });
      }

      var timer = setInterval(function () {
        show(index + 1);
      }, interval);

      dots.forEach(function (dot, j) {
        dot.addEventListener('click', function () {
          clearInterval(timer);
          show(j);
          timer = setInterval(function () {
            show(index + 1);
          }, interval);
        });
      });
    });
  }

  function initDrawer() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!toggle || !drawer) return;

    var backdrop = drawer.querySelector('.drawer__backdrop');
    var closeBtn = drawer.querySelector('[data-drawer-close]');

    function open() {
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) close();
      else open();
    });
    if (backdrop) backdrop.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
  }

  function initExhaustCatalog() {
    var root = document.querySelector('[data-exhaust-catalog]');
    if (!root) return;
    var filters = root.querySelectorAll('[data-exhaust-filter]');
    var items = root.querySelectorAll('[data-exhaust-item]');

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var brand = btn.getAttribute('data-brand') || 'all';
        filters.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        items.forEach(function (card) {
          var b = card.getAttribute('data-brand') || '';
          var show = brand === 'all' || b === brand;
          card.hidden = !show;
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeroSliders();
    initDrawer();
    initExhaustCatalog();
  });
})();
